// extracted by mini-css-extract-plugin
export default {"text":"Success_text__ZD9bS","title":"Success_title__v+69b"};